module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--stretch"
  }, [_c('div', {
    staticClass: "rect rect-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "rect rect-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "rect rect-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "rect rect-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "rect rect-5"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-733d8309","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/StretchLoading.vue
// module id = 646
// module chunks = 1